import GLightbox from 'glightbox';

let Product = {
  Initalised : false,
  
}

Product.init = function()
{
  if(!this.Initalised)
  {
    this.Initalised = true;
  }else{
    return false;
  }

  this.lightbox = GLightbox({
    touchNavigation: true,
    onOpen: () => {
      console.log('Lightbox opened')
    },
    beforeSlideLoad: (slide, data) => {
        
    }
  });

  this.enquireButton = document.getElementById('product-enquire-button');
  if(this.enquireButton){
    this.enquireButton.addEventListener('click',() => {
      var scrollTo = document.getElementById('product-enquire-form-contain');
      if(scrollTo){
        var scroll = require('window-scroll');
        var topPos = scrollTo.getBoundingClientRect().top + scroll.getScrollY();
        window.scrollTo(0,topPos);
      }
    });
  }
  

  this.variations = {};
  this.activeVariation = null;
  if('productVariations' in Window){
    this.variations = Window.productVariations;
  }

  this.productImage = document.getElementById('product-image');
  this.allImages = document.getElementById('product-images');
  this.variationCode = document.getElementById('product-variation-code');
  this.variationName = document.getElementById('product-variation-name');
  this.variationButtons = document.querySelectorAll("div[data-color]");
  this.variationSize = document.getElementById('product-variation-table');
  for(var i = 0; i < this.variationButtons.length; i++){
    var variation = this.variationButtons[i];

    if(variation.classList.contains('active')){
      this.setActiveVariation(variation);
    }

    variation.addEventListener('click', (event) => {
      var target = event.currentTarget;
      this.processColorClick(target);
    });
  }

  if(this.productImage){
    this.productImage.addEventListener('click', (event) => {
      this.lightbox.open();
    });
  }
  
}

Product.processColorClick = function(button){
  this.setActiveVariation(button);
}

Product.setActiveVariation = function(variation){
  var variationName = variation.dataset.color;
  if(variationName in this.variations){

    if(this.activeVariation != null){
      this.activeVariation.classList.remove('active');
    }
    this.activeVariation = variation;
    this.activeVariation.classList.add('active');

    this.variationName.innerHTML = this.variations[variationName].name;
    this.changeProductImages(this.variations[variationName].images);
    this.changeLightBoxElements(this.variations[variationName].images);
    this.changeProductTable(this.variations[variationName].sizes);
  }
}

Product.changeProductImages = function(images){
  
  this.allImages.innerHTML = '';
  var tempNodeList = [];

  for(var i = 0; i < images.length; i++){
    var v = images[i];

    var vElement = document.createElement('DIV');
    vElement.classList.add('image-choice');
    vElement.style.backgroundImage = "url("+v.url+")";

    if(i == 0){
      this.productImage.style.backgroundImage = "url("+v.url+")";
      vElement.classList.add('active');
      this.activeProductImage = vElement;
    }

    this.allImages.appendChild(vElement);

    vElement.addEventListener('click', (event) => {
      var target = event.currentTarget;
      this.productImage.style.backgroundImage = target.style.backgroundImage;
      this.activeProductImage.classList.remove('active');
      this.activeProductImage = target;
      this.activeProductImage.classList.add('active');
    })
  }
}

Product.changeProductTable = function(sizes){

  var aSizes = document.getElementById('color-available-sizes');
  aSizes.innerHTML = sizes;

  // var headers = sizes.headers;
  // var sizeValues = sizes.values;

  // this.variationSize.innerHTML = " ";

  // var tHead = document.createElement('THEAD');
  // var headerRow = document.createElement('TR');

  // for(var i = 0; i < headers.length; i++){
  //   var td = document.createElement('TD');
  //   td.innerHTML = headers[i];

  //   headerRow.appendChild(td);
  // }

  // tHead.appendChild(headerRow);

  // var tBody = document.createElement('TBODY');

  // for(var i = 0; i < sizeValues.length; i++){
  //   var tr = document.createElement('TR');
  //   for(var j = 0; j < sizeValues[i].length; j++){
  //     var td = document.createElement('TD');
  //     td.innerHTML = sizeValues[i][j];
  //     tr.appendChild(td);
  //   }
    

  //   tBody.appendChild(tr);
  // }

  // this.variationSize.appendChild(tHead);
  // this.variationSize.appendChild(tBody);
}

Product.changeLightBoxElements = function(images){

  var newElements = [];
  for(var i = 0; i < images.length; i++){
    newElements.push({
      href: images[i].url,
      type: 'image'
    })
  } 
  console.log(newElements);
  this.lightbox.setElements(newElements);
}




export default Product;


// WEBPACK FOOTER //
// ./resources/assets/js/components/product-variations.js